import {Component, OnInit, AfterViewInit} from '@angular/core';
import { AppConfigService } from '../../../../Services/app-config.service';
import {DataService} from '../../../../Services/data.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../Services/notification.service';
import { DateFilterService } from '../../../../Services/dateFilter.service';
import { ResponseModel } from '../../../../DataModels/response-model';
import { NgbPaginationConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagerStateService } from '../../../../Services/pager-state.service';
import { NgbpaginationConfigService } from '../../../../Services/ngbpagination-config.service';
import {Title} from '@angular/platform-browser';
import {ListPageBase} from '../../../list-page-base';

@Component({
  selector: 'app-currency-rate-list',
  templateUrl: './currency-rate-list.component.html',
  styleUrls: ['./currency-rate-list.component.css'],
  standalone: false
})
export class CurrencyRateListComponent extends ListPageBase implements OnInit, AfterViewInit {
  constructor(
    private table: DataService,
    private toastr: NotificationService,
    private dateFilter: DateFilterService,
    private ngbConfig: NgbPaginationConfig,
    private pagerConfig: NgbpaginationConfigService,
    private titleService: Title
  ) {
    super();
    this.ngbConfig = this.pagerConfig.getNgbPaginationConfig();
  }

  currencyRateList: Array<any>;
  currencyRateCount = 0;
  isLoaded = false;



  vm: any = [];

  getData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('currency_rate' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.currencyRateCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.toastr.error($localize`:Error loading currency rates @@errorLoadingCurrencyRates:Error loading currency rates`);
        console.log(error);
      },
      () => {}
    );
  }

  ngOnInit() {
    this.restorePagerState();
    this.vm.list = [];
    this.getData();
  }

  ngAfterViewInit() {
    this.titleService.setTitle($localize`:Currency Rate List @@currencyRateList:Currency Rate List`);
  }

  onNavigate(aID: string) {
    this.router.navigate(['admin/currency-rate-form', { id: aID }]);
  }

  // ----------------- Server side paging --------------------

  protected fetchPage(): void {
    this.getPagedApiData();
  }

  getPagedApiData() {
    let paramString =
      '?search=' + (this.vm.searchTerm ? this.vm.searchTerm : '');
    paramString +=
      '&fromDate=' +
      (this.vm.fromDate ? this.dateFilter.GetDateFormat(this.vm.fromDate) : '');
    paramString +=
      '&toDate=' +
      (this.vm.toDate ? this.dateFilter.GetDateFormat(this.vm.toDate) : '');
    paramString += '&pageNumber=' + (this.page !== 0 ? this.page - 1 : 0);
    paramString += '&pageSize=' + this.pageSize;

    this.table.getApiListData('currency_rate' + paramString).subscribe(
      (result: ResponseModel) => {
        this.vm.list = result.Data;
        this.totalRecords = result.totalRecords;
        this.paginate(false);
        this.currencyRateCount = result.totalRecords;
        this.isLoaded = true;
      },
      (error: HttpErrorResponse) => {
        // this.toastr.error($localize`:Error loading currency rates @@errorLoadingCurrencyRates:Error loading currency rates`);
        console.log(error);
      },
      () => {}
    );
  }

  serverSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  clearServerSearch(value) {
    this.vm.searchTerm = value.searchTerm;
    this.vm.fromDate = value.fromDate;
    this.vm.toDate = value.toDate;
    this.page = 1;
    this.getPagedApiData();
  }

  hideSearch() {
    this.vm.searchHidden = !this.vm.searchHidden;
  }
}
